import { Instagram, Facebook, Youtube } from "lucide-react";
import { CONTACT } from "@/data/content";

const TikTokIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9v2.6c-1.3.1-2.5-.3-3.5-.9v6.3c0 3.4-2.7 5.9-6 5.9-3.1 0-5.5-2.2-5.5-5.2 0-3.1 2.5-5.3 5.6-5.1v2.7c-.4-.1-.9-.2-1.3-.2-1.3 0-2.4 1-2.4 2.4 0 1.4 1 2.5 2.4 2.5 1.5 0 2.6-1.1 2.6-2.9V3h4.1z" />
  </svg>
);

const LINKS = [
  { key: "instagram", label: "Instagram", Icon: Instagram, url: CONTACT.instagram },
  { key: "facebook", label: "Facebook", Icon: Facebook, url: CONTACT.facebook },
  { key: "youtube", label: "YouTube", Icon: Youtube, url: CONTACT.youtube },
  { key: "tiktok", label: "TikTok", Icon: TikTokIcon, url: CONTACT.tiktok },
];

export default function SocialLinks() {
  const links = LINKS.filter((l) => l.url);
  return (
    <section id="socialni-site" className="py-20 px-5 border-t border-white/5" data-testid="social-section">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="font-head text-3xl sm:text-4xl text-neutral-100 mb-3 vhs-glitch">Sociální sítě</h2>
        <p className="text-sm text-neutral-500 mb-10 max-w-lg mx-auto">Sleduj GATE ESCAPE — zákulisí, novinky a atmosféru hry HUBERT.</p>
        <div className="flex flex-wrap justify-center gap-4">
          {links.map(({ key, label, Icon, url }) => (
            <a key={key} href={url} target="_blank" rel="noreferrer" data-testid={`social-${key}`}
              className="group flex items-center gap-3 px-6 py-4 border border-white/10 bg-[#0b0b0b] hover:border-nv/50 transition-colors">
              <Icon className="w-6 h-6 text-neutral-300 group-hover:text-nv transition-colors" />
              <span className="font-head tracking-widest text-sm text-neutral-200 group-hover:text-nv uppercase">{label}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
